import * as React from "react";
import { createContext, useContext } from "react";
import { Workspace } from "@radarly/models/workspace";

const WorkspaceContext = createContext<Workspace>(null);

export function useWorkspace() {
  return useContext(WorkspaceContext);
}

interface IProps {
  children: React.ReactNode;
  workspace: Workspace;
}

export const WorkspaceProvider = ({ children, workspace }: IProps) => {
  return (
    <WorkspaceContext.Provider value={workspace}>
      {children}
    </WorkspaceContext.Provider>
  );
};
